// Loads the Razorpay Checkout script once and resolves when ready.
let loadingPromise = null;

export function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (loadingPromise) return loadingPromise;
  loadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => { loadingPromise = null; reject(new Error("Failed to load Razorpay checkout")); };
    document.body.appendChild(script);
  });
  return loadingPromise;
}
